/*
 * @Author: QZJ
 * @Date:   2017-09-29 20:47:26
 * @Last Modified by:   Qzj
 * @Last Modified time: 2017-10-13 16:32:16
 */
import Cookies from 'js-cookie';
import _ from 'lodash';

/**
 * 存取删cookie
 */
export const cookie = {
  setItem(name, value, param) {
    const config = Object.assign(
      {
        expires: '',
        path: '/'
      },
      param
    );
    Cookies.set(name, value, config);
  },
  getItem(name) {
    return Cookies.get(name);
  },
  delItem(name) {
    Cookies.remove(name);
  }
};

export const getCookie = name => {
  let reg = new RegExp('(^| )' + name + '(?:=([^]*))?(|$)');
  let val = document.cookie.match(reg);
  return val ? (val[2] ? unescape(val[2]) : '') : null;
};

export const setCookie = (
  name,
  value,
  expires = '',
  path = '/',
  domain = '',
  secure = false
) => {
  let exp = new Date();
  /* eslint-disable*/
  expires ? exp.setMinutes(exp.getMinutes() + parseInt(expires)) : '';
  document.cookie =
    name +
    '=' +
    escape(value) +
    (expires ? 'expires=' + exp.toGMTString() : '') +
    (path ? 'path=' + path : '') +
    (domain ? 'domain=' + domain : '') +
    (secure ? 'secure' : '');
};

export const delCookie = (name, path = '/', domain, secure) => {
  let value = getCookie(name);
  if (value != null) {
    const exp = new Date();
    exp.setMinutes(exp.getMinutes() - 1000);
    document.cookie =
      name +
      '=expires=' +
      exp.toGMTString() +
      (path ? 'path=' + path : '') +
      (domain ? 'domain=' + domain : '') +
      (secure ? 'secure' : '');
  }
};
/**
 * 检测是否ios
 */
const userAgent = navigator.userAgent.toLowerCase();
export const isIOS = /iphone|ipad|ipod/.test(userAgent);

export const getQuery = (name, url) => {
  const u = url || window.location.search;
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  const r = u.substr(u.indexOf('?') + 1).match(reg);
  return r !== null ? r[2] : '';
};
export const getQueryObj = (name, url) => {
  let search = url || window.location.search;
  if (!search.includes('?')) search = '?' + search;
  let reg = /(?:^\?|&)(.*?)=(.*?)(?=&|$$)/g;
  let temp;
  let result = {};
  while ((temp = reg.exec(search)) != null) {
    result[decodeURIComponent(temp[1])] = decodeURIComponent(temp[2]);
  }
  if (name) {
    return result[name];
  } else {
    return result;
  }
};

/**
 * 存储localstorage
 * @param {*} key: 键名
 * @param {*} value: 值
 * @param {*} num: 最大数量
 */
export const setStore = (key, value, num) => {
  if (!key) return;
  if (num) {
    const val = localStorage.getItem(key) || '';
    const arr = val ? JSON.parse(val) : [];
    const index = arr.findIndex(el => el === value);
    if (index !== -1) {
      arr.splice(index, 1);
    }
    arr.unshift(value);
    if (arr.length > num) {
      arr.pop();
    }
    localStorage.setItem(key, JSON.stringify(arr));
    return;
  }
  localStorage.setItem(key, JSON.stringify(value));
};

/**
 * 获取localStorage
 */
export const getStore = key => {
  if (!key) return;
  let val = localStorage.getItem(key) || '';
  if (val) {
    val = JSON.parse(val);
  }
  return val;
};

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
};

/**
 * 获取元素计算属性
 */
// export const getDomStyle = (selector, name) => {
//   const dom = document.querySelector(selector)
//   if (!dom) return null
//   return window.getComputedStyle(dom, null)[name] ? window.getComputedStyle(dom, null)[name] : null
// }

export const getStyle = (elem, prop) => {
  // elem dom元素  prop 元素属性
  if (window.getComputedStyle) {
    return window.getComputedStyle(elem, null)[prop]; // null可以替换成伪类元素，可以得到伪类元素的属性值
  } else {
    return elem.currentStyle[prop];
  }
};
export const isChildNode = (parentNode, target) => {
  let rs = false;
  while (target.parentElement && target !== parentNode) {
    target = target.parentElement;
  }
  if (target === parentNode) {
    rs = true;
  }
  return rs;
};

/*
 * 获取容器大小
 */
export const getWrapSize = elem => {
  // elem dom元素
  if (!elem) return false;
  let w = elem.scrollWidth;
  let h = elem.scrollHeight;
  return {
    w,
    h
  };
};
/*
 * 获取容器offset大小
 */
export const getWrapOffsetSize = elem => {
  // elem dom元素
  if (!elem) return false;
  let w = elem.offsetWidth;
  let h = elem.offsetHeight;
  return {
    w,
    h
  };
};
/*
 * 获取浏览器宽高
 */
export const getBrowserSize = () => {
  let w, h;
  // 获取窗口宽度
  if (window.innerWidth) {
    w = window.innerWidth;
  } else if (document.body && document.body.clientWidth) {
    w = document.body.clientWidth;
  }
  // 获取窗口高度
  if (window.innerHeight) {
    h = window.innerHeight;
  } else if (document.body && document.body.clientHeight) {
    h = document.body.clientHeight;
  }
  return {
    w,
    h
  };
};
/**
 * 去除两边空格
 */
export const trim = str => {
  return String(str).replace(/^\s*|\s*$/g, '');
};
export const trimAll = str => {
  return String(str).replace(/\s/g, '');
};

export const fen2yuan = str => {
  let fen = parseInt(str, 10);
  return fen / 100 || 0;
};

export const yuan2fen = str => {
  let yuan = parseFloat(str, 10);
  return parseInt(yuan * 100);
};

// 获取指定月份天数
export const getDate = date => {
  let d = new Date(date);
  let y = d.getFullYear();
  let m = d.getMonth() + 1;
  let D = new Date(y, m, 0);
  return Number(D.getDate());
};
// 获取对应时间
export const getTime = time => {
  let t = time
    ? new Date(typeof time === 'string' ? time.replace(/-/g, '/') : time)
    : new Date();
  return {
    y: t.getFullYear(),
    m: t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1,
    d: t.getDate() < 10 ? '0' + t.getDate() : t.getDate(),
    h: t.getHours() < 10 ? '0' + t.getHours() : t.getHours(),
    M: t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes(),
    s: t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
  };
};
// 数组按照 key 排序 num
export const sortArrBykey = key => {
  return function(x, y) {
    return -(x[key] - y[key]);
  };
};

// 获取元素偏移量
export const getOffset = obj => {
  let [left, top] = [0, 0];
  const get = o => {
    left += o.offsetLeft;
    top += o.offsetTop;
    if (o.offsetParent.tagName !== 'BODY') {
      get(o.offsetParent);
    }
    return {
      left,
      top
    };
  };
  return get(obj);
};

// 图片预加载
export const preloadimages = arr => {
  let newimages = [];
  for (var i = 0; i < arr.length; i++) {
    newimages[i] = new Image();
    newimages[i].src = arr[i];
  }
};
// 检测是否过期
export const isDated = (date, lastDate) => {
  let dateStr = new Date(date).getTime();
  let lastDateStr = new Date(lastDate).getTime();
  return lastDateStr - dateStr < 0;
};

// 克隆
export const deepClone = data => {
  return _.cloneDeep(data);
};

// 千位分隔符
export const numFormat = num => {
  let res = num.toString().replace(/\d+/, n => {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, $1 => {
      return $1 + ',';
    });
  });
  return res;
};
/**
 * dom class操作
 * @Author    qzj
 * @DateTime  2018-03-20
 * @copyright [copyright]
 * @license   [license]
 * @version   [version]
 * @param     {[type]}    ele [description]
 * @param     {[type]}    cls [description]
 * @return    {[type]}        [description]
 */
export const hasClass = (ele, cls) => {
  return ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
};

export const addClass = (ele, cls) => {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls;
};

export const removeClass = (ele, cls) => {
  if (hasClass(ele, cls)) {
    var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
    ele.className = ele.className.replace(reg, ' ');
  }
};

export const toggleClass = (ele, cls) => {
  if (hasClass(ele, cls)) {
    removeClass(ele, cls);
  } else {
    addClass(ele, cls);
  }
};

// 防抖
export const debounce = (fun, delay = 100) => {
  return _.debounce(fun, delay);
};

// 节流
export const throttle = (fun, delay = 100) => {
  return _.throttle(fun, delay);
};

export const createIframe = url => {
  let iframe = document.createElement('iframe');
  iframe.style.visibility = 'hidden';
  iframe.style.display = 'none';
  iframe.style.height = '0';
  iframe.style.width = '0';
  iframe.setAttribute('src', url);
  let iframeCallback = function() {
    setTimeout(function() {
      iframe.removeEventListener('load', iframeCallback);
      document.body.removeChild(iframe);
    }, 0);
  };
  iframe.addEventListener('load', iframeCallback);
  document.body.appendChild(iframe);
};
/**
 * 设置页面title
 * 兼容ios下无法动态修改title
 */
export const setMetaTitle = title => {
  document.title = title;
  // isIOS && createIframe('/static/img/ico_close.png');
};

export const isMobile = tel => {
  return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(
    tel
  );
};

export const isIMEI = imei => {
  return /^\d{15,18}$/.test(imei);
};

export const isIdcard = idcard => {
  return /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(
    idcard
  );
};

// 是否为中文
export const isChinese = text => {
  return /^[\u4e00-\u9fa5]+$/gm.test(text);
};

// 转换blob
export const dataURLtoBlob = dataurl => {
  let arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: mime
  });
};

export const getValueByPath = function(object, prop) {
  prop = prop || '';
  const paths = prop.split('.');
  let current = object;
  let result = null;
  for (let i = 0, j = paths.length; i < j; i++) {
    const path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }
    current = current[path];
  }
  return result;
};

export const valueEquals = (a, b) => {
  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
  if (a === b) return true;
  if (!(a instanceof Array)) return false;
  if (!(b instanceof Array)) return false;
  if (a.length !== b.length) return false;
  for (let i = 0; i !== a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

export function toObject(arr) {
  var res = {};
  for (let i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res;
}

export const toFixed = (num, retainNum = 2) => {
  if (isNaN(num)) return num;
  return fen2yuan(num).toFixed(retainNum);
};

export const getID = (() => {
  let id = 1;
  return () => {
    return id++;
  };
})();

/**
 * 时间格式化 new Date(), "{y}-{m}-{d} {h}:{i}:{s}"
 */
export const parseTime = (time, cFormat) => {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    // eslint-disable-next-line no-param-reassign
    if (String(time).length === 10) time = parseInt(time, 10) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  return format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
};

/**
 * 获取num天前日期
 * @param {*} num
 */
export const lastDay = (num = 1) => {
  let day = new Date();
  day.setTime(day.getTime() - num * 24 * 60 * 60 * 1000);
  const formatDate =
    day.getFullYear() + '-' + (day.getMonth() + 1) + '-' + day.getDate();
  return formatDate;
};

/**
 * 获取num个月前的今天 return年月日时间格式
 */
export const lastMonthTime = (num = 1) => {
  const nowdate = new Date();
  nowdate.setMonth(nowdate.getMonth() - num);

  function zeroFill(val) {
    const value = Number(val);
    if (value >= 10) return val;
    return `0${value}`;
  }
  const y = nowdate.getFullYear();
  const m = zeroFill(nowdate.getMonth() + 1);
  const d = zeroFill(nowdate.getDate());
  const formatDate = y + '-' + m + '-' + d;
  return formatDate;
};

/**
 * 删除url中的参数，并返回新的url
 */
export const delParam = paramKey => {
  var url = window.location.href; //页面url
  var urlParam = window.location.search.substr(1); //页面参数
  var beforeUrl = url.substr(0, url.indexOf('?')); //页面主地址（参数之前地址）
  var nextUrl = '';

  var arr = new Array();
  if (urlParam != '') {
    var urlParamArr = urlParam.split('&'); //将参数按照&符分成数组
    for (var i = 0; i < urlParamArr.length; i++) {
      var paramArr = urlParamArr[i].split('='); //将参数键，值拆开
      //如果键与要删除的不一致，则加入到参数中
      if (paramArr[0] != paramKey) {
        arr.push(urlParamArr[i]);
      }
    }
  }
  if (arr.length > 0) {
    nextUrl = '?' + arr.join('&');
  }
  url = beforeUrl + nextUrl;
  return url;
};

/**
 * 设置url拼接参数
 * @param {*} options {url: '', query: {}}
 */
export const setUrlQuery = options => {
  let { url, query } = options;
  if (!url) return '';
  if (query) {
    let queryArr = [];
    for (const key in query) {
      if (query.hasOwnProperty(key)) {
        queryArr.push(`${key}=${query[key]}`);
      }
    }
    if (url.indexOf('?') !== -1) {
      url = `${url}&${queryArr.join('&')}`;
    } else {
      url = `${url}?${queryArr.join('&')}`;
    }
  }
  return url;
};

/**
 * 获取入参数据类型
 * @param {*} value
 */
export const getTypeOf = value => {
  let data = Object.prototype.toString.call(value);
  data = data.substring(8, data.length - 1);
  return data;
};

/**
 * 当前距传入时间的相差时间
 * @param {*} dateTime
 */
export const getDistanceSpecifiedTime = (dateTime, now = '') => {
  if (!dateTime) return {};
  const time = dateTime.replace(/\-/g, '/');
  const time1 = now.replace(/\-/g, '/');
  const EndTime = new Date(time);
  const NowTime = time1 ? new Date(time1) : new Date();
  let t;
  if (EndTime > NowTime) {
    t = EndTime.getTime() - NowTime.getTime();
  } else {
    t = NowTime.getTime() - EndTime.getTime();
  }
  const d = Math.floor(t / 1000 / 60 / 60 / 24);
  const h = Math.floor((t / 1000 / 60 / 60) % 24);
  let m = Math.floor((t / 1000 / 60) % 60);
  const s = Math.floor((t / 1000) % 60);
  let str = '';
  if (d > 0) str += `${d}天`;
  if (h > 0) str += `${h}小时`;
  if (m <= 0) m = 1;
  str += `${m}分钟`;
  return {
    d,
    h,
    m,
    s,
    time: str
  };
};

/**
 * 秒转时分秒
 * @param {*} second: 秒
 */
export const secondToDate = s => {
  if (!s) return '0秒';
  const second = Number(s);
  if (isNaN(second) || second === 0) return '0秒';
  var h = Math.floor(second / 3600);
  var m = Math.floor((second / 60) % 60);
  var s = Math.floor(second % 60);
  let res = '';
  if (h !== 0) res += `${h}小时`;
  if (m !== 0) res += `${m}分钟`;
  if (s !== 0) res += `${s}秒`;
  return res;
};

/**
 * 动态引入script
 * @param {*} url: js路径 callback: 回调方法
 */
export const createJs = (url, callback) => {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  if (typeof callback != 'undefined') {
    if (script.readyState) {
      script.onreadystatechange = function() {
        if (script.readyState == 'loaded' || script.readyState == 'complete') {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = function() {
        callback();
      };
    }
  }
  script.src = url;
  document.body.appendChild(script);
};

/**
 * 动态引入script跨域
 * @param {*} url: js路径 callback: 回调方法
 */
export const createJsCrossOrigin = (url, callback) => {
  var script = document.createElement('script');
  script.crossOrigin = 'true';
  script.type = 'text/javascript';
  if (typeof callback != 'undefined') {
    if (script.readyState) {
      script.onreadystatechange = function() {
        if (script.readyState == 'loaded' || script.readyState == 'complete') {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = function() {
        callback();
      };
    }
  }
  script.src = url;
  document.body.appendChild(script);
};

/**
 * 加减乘除运算
 */
export const math = {
  /**
   * 加法
   */
  add: (augend, addend) => {
    (augend = augend.toString()), (addend = addend.toString());
    const arg1Arr = augend.split('.'),
      arg2Arr = addend.split('.'),
      d1 = arg1Arr.length == 2 ? arg1Arr[1] : '',
      d2 = arg2Arr.length == 2 ? arg2Arr[1] : '';
    const maxLen = Math.max(d1.length, d2.length);
    const m = Math.pow(10, maxLen);
    const result = Number(((augend * m + addend * m) / m).toFixed(maxLen));
    const d = arguments[2];
    return typeof d === 'number' ? Number(result.toFixed(d)) : result;
  },
  /**
   * 减法
   */
  subtract: (minuend, subtrahend) => {
    return Calc.Add(minuend, -Number(subtrahend), arguments[2]);
  },
  /**
   * 乘法
   */
  multiply: (multiplier, multiplicand) => {
    let r1 = multiplier.toString(),
      r2 = multiplicand.toString(),
      m,
      resultVal,
      d = arguments[2];
    m =
      (r1.split('.')[1] ? r1.split('.')[1].length : 0) +
      (r2.split('.')[1] ? r2.split('.')[1].length : 0);
    resultVal =
      (Number(r1.replace('.', '')) * Number(r2.replace('.', ''))) /
      Math.pow(10, m);
    return typeof d !== 'number'
      ? Number(resultVal)
      : Number(resultVal.toFixed(parseInt(d)));
  },
  /**
   * 除法
   */
  divide: (dividend, divisor) => {
    let r1 = dividend.toString(),
      r2 = divisor.toString(),
      m,
      resultVal,
      d = arguments[2];
    m =
      (r2.split('.')[1] ? r2.split('.')[1].length : 0) -
      (r1.split('.')[1] ? r1.split('.')[1].length : 0);
    resultVal =
      (Number(r1.replace('.', '')) / Number(r2.replace('.', ''))) *
      Math.pow(10, m);
    return typeof d !== 'number'
      ? Number(resultVal)
      : Number(resultVal.toFixed(parseInt(d)));
  }
};

/**
 * 获取今天到num天后之间的日期
 * @param {*} num: 天数
 */
export const getAfterDays = (num = 30) => {
  const startDate = new Date();
  const endDate = new Date();
  endDate.setDate(startDate.getDate() + num);
  const dataArr = [];
  const weeks = ['日', '一', '二', '三', '四', '五', '六'];
  while (endDate.getTime() - startDate.getTime() >= 0) {
    const year = startDate.getFullYear().toString();
    const month =
      (startDate.getMonth() + 1).toString().length == 1
        ? '0' + (startDate.getMonth() + 1).toString()
        : startDate.getMonth() + 1;
    const day =
      startDate.getDate().toString().length == 1
        ? '0' + startDate.getDate()
        : startDate.getDate();
    const week = weeks[startDate.getDay()];
    dataArr.push({
      date: `${month}月${day}日`,
      day: `星期${week}`,
      value: `${year}-${month}-${day}`
    });
    startDate.setDate(startDate.getDate() + 1);
  }
  return dataArr;
};

/**
 * 校验身份证
 * @param {*} code: 身份证号
 */
export const identityCodeValid = code => {
  const msg = {
    res: true,
    txt: ''
  };
  const city = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江 ',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北 ',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏 ',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '中国台湾',
    81: '中国香港',
    82: '中国澳门',
    91: '国外 '
  };

  if (
    !code ||
    !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
      code
    )
  ) {
    msg.res = false;
    msg.txt = '身份证号格式错误';
    return msg;
  }

  if (!city[code.substr(0, 2)]) {
    msg.res = false;
    msg.txt = '地址编码错误';
    return msg;
  }
  if (code.length == 18) {
    sBirthday =
      code.substr(6, 4) +
      '-' +
      Number(code.substr(10, 2)) +
      '-' +
      Number(code.substr(12, 2));
    var d = new Date(sBirthday.replace(/-/g, '/'));
    if (
      sBirthday !=
      d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
    ) {
      msg.res = false;
      msg.txt = '出生日期非法';
      return msg;
    }
  }
  //18位身份证需要验证最后一位校验位
  if (code.length == 18) {
    code = code.split('');
    //∑(ai×Wi)(mod 11)
    //加权因子
    var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    //校验位
    var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
    var sum = 0;
    var ai = 0;
    var wi = 0;
    for (var i = 0; i < 17; i++) {
      ai = code[i];
      wi = factor[i];
      sum += ai * wi;
    }
    var last = parity[sum % 11];
    if (parity[sum % 11] != code[17]) {
      msg.res = false;
      msg.txt = '校验位错误';
      return msg;
    }
  }
};

export const isZybApp = () => {
  const n = userAgent || window.navigator.userAgent;
  return /hsb_app_zyb/i.test(n);
}
